
import Vue from 'vue';
import Antd from 'ant-design-vue';
import router from '@/router/index.js'
import App from './App';
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;

Vue.use(Antd);

new Vue({
  render: h => h(App),
  router
}).$mount('#app')